import { render, staticRenderFns } from "./HoldStatus.vue?vue&type=template&id=12d2a3f4&"
import script from "./HoldStatus.vue?vue&type=script&lang=js&"
export * from "./HoldStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports